let productTag = document
    .getElementsByClassName('livearf-product-tags')[0]
    ?.getAttribute("data-tags");

if (productTag?.includes("frame only")) {

    // Remove cropped data
    Object.keys(localStorage)
        .filter(key => key.includes('_croppedData'))
        .forEach(key => localStorage.removeItem(key));

    // Show Size fieldset
    const sizeFieldset = document.querySelector('fieldset[name="Size"]');

    if (sizeFieldset) {
        sizeFieldset.style.setProperty('display', 'block', 'important');
    }
}